import { render, staticRenderFns } from "./tickertext.vue?vue&type=template&id=93af8ad4&scoped=true&"
import script from "./tickertext.vue?vue&type=script&lang=js&"
export * from "./tickertext.vue?vue&type=script&lang=js&"
import style0 from "./tickertext.vue?vue&type=style&index=0&id=93af8ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93af8ad4",
  null
  
)

export default component.exports